import { ENTITY_TYPES } from '@sales-center/common'
import {
  ILeadOppProduct,
  LeadOppProductOrder,
  LeadOppProductOrderInput,
} from '@user/store/leadOppProducts'

export function servicesToPOSTModel(
  serviceProducts: ILeadOppProduct[],
  entityType: ENTITY_TYPES,
): LeadOppProductOrderInput {
  return {
    entityType: entityType,
    leadOppProductOrders: serviceProducts.map(
      ({ id }, index): LeadOppProductOrder => ({
        id,
        order: index,
      }),
    ),
    entityId: serviceProducts.find((x) => x.entityId)?.entityId,
  }
}
